<button [id]="'button_basic-button_Basic'" mat-stroked-button color="{{ color }}">
    {{ textButton }}
</button>
